import { Editor as TinyMCEReact } from '@tinymce/tinymce-react';
import styled from 'styled-components';

import env from 'utils/env';
import { useTinyMceVersion } from 'modules/wysiwygEditor/hooks/useTinyMceVersion';

import { useContentErrors } from '../../../../hooks/form';
import { ErrorMessage } from './ErrorMessage';
import { useFocusState } from './hooks/useFocusState';
import { useInitialEditorConfig } from './hooks/useInitialEditorConfig';
import { useLinkDoubleClickHandler } from './hooks/useLinkDoubleClickHandler';
import { useTokensChangeHandler } from './hooks/useTokensChangeHandler';
import { Toolbar } from './toolbar';

const OuterWrapper = styled.div`
  grid-area: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.values.half};
`;

const InnerWrapper = styled.div<{ $isEditorFocused: boolean; $hasError: boolean }>`
  background-color: #fff;
  border: ${({ theme }) => theme.spacing.values.single} solid
    ${({ $hasError }) => ($hasError ? '#d14233' : '#c3c3c5')};
  border-radius: 6px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  outline-color: ${({ theme, $hasError }) =>
    $hasError ? '#d14233' : theme.colors.primaryColors.purple50};
  outline-width: ${({ theme }) => theme.spacing.values.eighth};
  outline-style: ${({ $isEditorFocused }) => ($isEditorFocused ? 'solid' : 'none')};
  outline-offset: -${({ theme }) => theme.spacing.values.single};

  &:focus-within {
    outline-style: solid;
  }

  .tox-tinymce {
    border-radius: 0;
    border: 0;
  }
`;

export const Editor = () => {
  const { isFocused } = useFocusState();
  const initialConfig = useInitialEditorConfig();
  const errors = useContentErrors();
  useLinkDoubleClickHandler();
  useTokensChangeHandler();

  const tinyMceVersion = useTinyMceVersion();

  return (
    <OuterWrapper>
      <InnerWrapper $isEditorFocused={isFocused} $hasError={!!errors} data-test="custom-text-input">
        <TinyMCEReact
          tinymceScriptSrc={`${env.publicPath}wysiwyg/${tinyMceVersion}/tinymce.min.js`}
          init={initialConfig}
        />
        <Toolbar />
      </InnerWrapper>
      {errors && <ErrorMessage />}
    </OuterWrapper>
  );
};
